import React from 'react'
import Svg from '../../../Svg'

const EnvelopeWithLetterHB = props => (
  <Svg width='147' height='146' viewBox='0 0 147 146' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M85.3428 101.236L144.429 56.288C145.516 55.4611 146.144 54.1672 146.12 52.8032C146.096 51.4392 145.424 50.1676 144.309 49.3793L75.6029 0.78888C74.1162 -0.26296 72.1258 -0.26296 70.6389 0.78888L1.93304 49.3793C0.81772 50.1679 0.145261 51.4392 0.121501 52.8032C0.0977399 54.1672 0.725539 55.4614 1.81252 56.288L60.899 101.236H85.3428Z'
      fill='#9D989B'
    />
    <rect x='12' y='53' width='121' height='82' rx='2' fill='#F5F5F5' />
    <path
      d='M141.827 146H4.41504C2.04354 146 0.12092 144.08 0.12092 141.711V52.4967C0.12092 51.8357 -1.25644 54.4057 5.28602 58.8821C15.6162 66.7589 60.3804 100.892 60.3804 100.892H85.8615L144.744 56.1275C145.777 54.75 146.121 53.717 146.121 52.4967V141.711C146.121 144.08 144.198 146 141.827 146Z'
      fill='#BBB2B7'
    />
    <path
      d='M1.49829 144.217L60.9936 100.719H85.2483L144.744 144.217C143.969 145.296 142.715 146 141.295 146H4.9465C3.52676 146 2.27264 145.296 1.49829 144.217Z'
      fill='#B5ADB1'
    />
    <path
      d='M144.743 144.217L85.2482 100.719L73.1208 100.719V146H141.295C142.715 146 143.969 145.296 144.743 144.217Z'
      fill='#C4BCC5'
    />
    <path
      d='M90.7831 102.548C90.7831 112.398 82.8232 120.375 73.0138 120.375C63.2045 120.375 55.2446 112.398 55.2446 102.548C55.2446 92.6972 63.2045 84.7197 73.0138 84.7197C82.8232 84.7197 90.7831 92.6972 90.7831 102.548Z'
      fill='#37393B'
      stroke='#FC5AA6'
      strokeWidth='3'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M76.8067 104.686C75.523 104.686 74.4822 103.643 74.4822 102.357C74.4822 101.07 75.5237 100.027 76.8067 100.027C78.0917 100.027 79.1318 101.07 79.1318 102.357C79.1318 103.643 78.0917 104.686 76.8067 104.686ZM69.2658 104.686C67.9815 104.686 66.9407 103.643 66.9407 102.357C66.9407 101.07 67.9815 100.027 69.2658 100.027C70.5502 100.027 71.5909 101.07 71.5909 102.357C71.5909 103.643 70.5502 104.686 69.2658 104.686ZM67.0144 110.948H69.5572H76.5006H79.0235C79.8565 110.948 80.5335 110.27 80.5335 109.435V106.869H81.419C81.869 106.869 82.2334 106.504 82.2334 106.054V102.76C82.2334 102.309 81.869 101.945 81.419 101.945H80.5335V98.7141C80.5335 97.8795 79.8572 97.2018 79.0235 97.2018H73.4381V96.2946C74.5751 96.1117 75.4446 95.1248 75.4446 93.9336C75.4446 92.6128 74.376 91.5427 73.0578 91.5427C71.7396 91.5427 70.6716 92.6128 70.6716 93.9336C70.6716 95.0908 71.4914 96.0552 72.5819 96.2767V97.2018H67.0138C66.1808 97.2018 65.5044 97.8788 65.5044 98.7141V101.945H64.607C64.1577 101.945 63.7939 102.31 63.7939 102.76V106.054C63.7939 106.504 64.1583 106.869 64.607 106.869H65.5051V109.435C65.5051 110.27 66.1808 110.948 67.0144 110.948ZM67.4996 107.837C67.4996 107.286 67.9463 106.839 68.4972 106.839H77.7857C78.3366 106.839 78.7833 107.286 78.7833 107.837C78.7833 108.388 78.3366 108.834 77.7857 108.834H68.4972C67.9463 108.834 67.4996 108.388 67.4996 107.837Z'
      fill='white'
    />
  </Svg>
)

export default EnvelopeWithLetterHB
